import { IdentityDocumentType } from '@services/identityVerification/IdentityVerification.types';
import { HoursDrivenPerWeek, TripsCompleted, UberTenure } from "@views/UberProof/UberProof.types";

export type DocumentDetail = {
  // Common document attributes
  documentType: IdentityDocumentType | null;
  documentNumber: string | null;
  expiryDate: string | null;

  // Specific to drivers licence or passport
  dateOfBirth: string | null;
  state: string | null;
  nationality: string | null;

  // Proof of Address fields
  issueDate: string | null;
  streetLine1: string | null;
  streetLine2: string | null;
  city: string | null;
  postCode: string | null;
  country: string | null;

  // Uber profile fields
  tripsCompleted: TripsCompleted | null;
  uberTenure: UberTenure | null;
  drivingHoursPerWeek: HoursDrivenPerWeek | null;
  uberRating: number | null;

  // Files to upload, if any
  frontFile: File | null;
  backFile: File | null;
};

export type DocumentDetailAction =
  | {
    type: "RESET";
  }
  | {
    type: "UPDATE_FIELD";
    payload: {
      field: keyof DocumentDetail;
      value: any;
    };
  };

export const documentDetailInitialState: DocumentDetail = {
  documentType: null,
  frontFile: null,
  backFile: null,
  documentNumber: null,
  expiryDate: null,
  dateOfBirth: null,
  state: null,
  nationality: null,
  issueDate: null,
  streetLine1: null,
  streetLine2: null,
  city: null,
  postCode: null,
  country: null,
  tripsCompleted: null,
  uberTenure: null,
  drivingHoursPerWeek: null,
  uberRating: null,
};

export function documentDetailReducer(
  state: DocumentDetail,
  action: DocumentDetailAction
): DocumentDetail {
  switch (action.type) {
    case "RESET":
      console.log(`Clearing fields due to document type change`);
      return documentDetailInitialState;

    case "UPDATE_FIELD":
      console.log(
        `Updating ${action.payload.field} in DocumentDetail (currently ${state.documentType} document type) ` +
        `with: ${action.payload.value}`
      );
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };

    default:
      console.log(`Error - incorrect action sent ${action} ${state}`);
      return state;
  }
}
